// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

export default {
  name: 'workspaces',
  title: 'label.workspaces',
  icon: 'InboxOutlined',
  docHelp: 'workspaces.html',
  permission: ['workspaceStatus', 'ansibleStatus'],
  children: [
    {
      name: 'workspaces/overview',
      title: 'label.workspaces.overview',
      icon: 'bars-outlined',
      permission: ['workspaceStatus', 'ansibleStatus'],
      component: () => import('@/views/plugins/workspaces/Manage.vue')
    },
    {
      name: 'workspaces/settings',
      title: 'label.workspaces.settings',
      icon: 'setting-outlined',
      permission: ['workspaceManagedScriptsList', 'workspaceManagedScriptsUpdate', 'workspaceConfigurationList', 'workspaceConfigurationUpdate'],
      component: () => import('@/views/plugins/workspaces/WorkspaceManagedScripts.vue')
    }
  ]
}
